module.exports = __webpack_public_path__ + "img/new_casual.2990836b.jpg";